import { paths as ROUTE_PATHS } from '@hero/routes/paths';

const SIDEBAR_STATUS = {
  soon: 'soon',
  disabled: 'disabled'
};

const TOUR_STEPS = {
  recognition: [
    {
      title: 'tourProgressStepList1',
      path: ROUTE_PATHS?.NEW_RECOGNITION_GIFTS
    },
    {
      title: 'chooseContactType',
      path: ROUTE_PATHS?.NEW_RECOGNITION_CONTACT_TYPE
    },
    {
      title: 'addRecipients',
      path: ROUTE_PATHS?.NEW_RECOGNITION_RECIPIENTS
    },
    {
      title: 'customizeExperience',
      path: ROUTE_PATHS?.NEW_RECOGNITION_EXPERIENCE
    },
    {
      title: 'reviewOrder',
      path: ROUTE_PATHS?.NEW_RECOGNITION_REVIEW_PAY()
    },
    {
      title: 'shareRecognition',
      path: ROUTE_PATHS?.NEW_RECOGNITION_SHARE()
    }
  ],
  automation: [
    {
      title: 'tourProgressStepList1',
      path: ROUTE_PATHS?.NEW_AUTOMATION_GIFTS
    },
    {
      title: 'rules',
      path: ROUTE_PATHS.NEW_AUTOMATION_RULES
    },
    {
      title: 'addRecipients',
      path: ROUTE_PATHS.NEW_AUTOMATION_RECIPIENTS
    },
    {
      title: 'customizeExperience',
      path: ROUTE_PATHS.NEW_AUTOMATION_EXPERIENCE
    },
    {
      title: 'reviewOrder',
      path: ROUTE_PATHS.NEW_AUTOMATION_REVIEW_ACTIVE()
    }
  ]
};

export { SIDEBAR_STATUS, TOUR_STEPS };
